import { Pipe, PipeTransform } from '@angular/core';

import { enumToDescription } from '@shared/util';

@Pipe({
    name: 'enumToDescription',
    standalone: true,
})
export class EnumToDescriptionPipe implements PipeTransform {
    transform(enumValue: number | string, enumeration: object, useExplicitMappings = false): string {
        return enumToDescription({ enumeration, enumValue, useExplicitMappings });
    }
}
